import React from 'react';
import PropTypes from 'prop-types';
import Button from 'client/component-library/buttons/ButtonAdmin/afsButton';

export function ClusterActionButtons({
  onAddFundingData,
  onArchive,
  onDiscard,
  disabledAddFunding,
}) {
  return (
    <div className="w-2/12 px-1">
      <div className="p-2">
        <Button
          onClick={onAddFundingData}
          disabled={disabledAddFunding}
          data-test="add-funding-button"
        >
          Add Funding Data
        </Button>
      </div>
      <div className="flex flex-col mx-2 border-t">
        <div className="pt-2 flex-1">
          <Button
            onClick={onArchive}
            theme="success"
            data-test="archive-cluster-button"
          >
            Archive
          </Button>
        </div>
        <div className="pt-2 flex-1">
          <Button
            onClick={onDiscard}
            theme="danger"
            data-test="discard-cluster-button"
          >
            Discard
          </Button>
        </div>
      </div>
    </div>
  );
}

ClusterActionButtons.propTypes = {
  onAddFundingData: PropTypes.func.isRequired,
  onArchive: PropTypes.func.isRequired,
  onDiscard: PropTypes.func.isRequired,
  disabledAddFunding: PropTypes.bool.isRequired,
};
